import logo from './images/Mobile2Logo.svg';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { RoutesProgress, TodosComponent } from './components/TodoComponents';
import { useContext, useState } from 'react';
import { AccountContext } from './contexts/AccountContexts';
import { PageHeader } from './components/HeaderComponents';
import { AddChangelogComponent, ChangelogComponent } from './components/ChangelogComponents';


function Portal() {

    const { user } = useContext(AccountContext)
    const [addlog, setAddlog] = useState(false)
    const navigator = useNavigate();

    const doneCallback = () => {
        setAddlog(false)
    }

    return (
        <div className="">
            <PageHeader pageTitle={"Main"} />
            <div className="bg-[#282c34] h-screen text-white flex items-center justify-center gap-5">
                <div className='flex flex-col items-center w-1/2 justify-start mb-auto'>

                    {
                        user && user.name === "GMC2F7" &&
                        <button className='btn btn-sm w-32' onClick={() => setAddlog(!addlog)}>Switch</button>
                    }

                    {
                        addlog ?
                            <AddChangelogComponent callback={doneCallback} />
                            :
                            <div className='overflow-auto max-h-[800px]'>
                                <ChangelogComponent />
                            </div>
                    }

                </div>
                {
                    user && user.class === "dev" &&
                    <div>
                        <TodosComponent />
                    </div>
                }
            </div>
        </div>
    );
}

export default Portal;
